import {
  RequirementChecklist,
  type RequirementItem,
} from "Components/Shared/Inputs/RequirementChecklist";
import { passwordRequirements } from "Schemas/passwordSchema";
import { useResource } from "Translations/Resources";

type Props = {
  password: string;
  extraRequirements?: ReadonlyArray<RequirementItem>;
};

export const PasswordRequirements = ({
  password,
  extraRequirements = [],
}: Props) => {
  const { t } = useResource();

  const items: ReadonlyArray<RequirementItem> = [
    ...passwordRequirements.map((requirement) => ({
      id: requirement.id,
      label: requirement.getLabel(t),
      isSatisfied: requirement.isSatisfiedBy(password),
    })),
    ...extraRequirements,
  ];

  return <RequirementChecklist items={items} />;
};
